import script from "./ProductList.vue?vue&type=script&lang=ts&setup=true&name=ProductList"
export * from "./ProductList.vue?vue&type=script&lang=ts&setup=true&name=ProductList"

import "./ProductList.vue?vue&type=style&index=0&id=dbcade20&scoped=true&lang=stylus"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbcade20"]])

export default __exports__